import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { feedbackBackend } from './feedback.backend';
import { feedbackReducer } from './feedback.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('feedback', feedbackReducer),
    BackendModule.forFeature('feedback', feedbackBackend),
  ],
})
export class DatastoreFeedbackModule {}
